import React, { useContext } from "react";
import "./Purchased_Items_Modal.css";
import "react-step-progress-bar/styles.css";
import { ProgressBar, Step } from "react-step-progress-bar";
import { Modal } from "react-bootstrap";
import Common_Button from "../../Common-Component/Common_Button/Common_Button";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { useNavigate } from "react-router-dom";

function Purchased_Items_Modal(props) {
  var stepPercentage = 0;

  const navigate = useNavigate();
  if (props.currentStep === 1) {
    stepPercentage = 0;
  } else if (props.currentStep === 2) {
    stepPercentage = 50;
  } else if (props.currentStep === 3) {
    stepPercentage = 100;
  } else {
    stepPercentage = 0;
  }

  const { IMG_URL, userdata } = useContext(Context);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(2);
    return `${day}/${month}/${year}`;
  }

  const today = new Date();

  // Ensure `createdAt` is a Date object
  const createdAt = new Date(props?.data?.createdAt);

  const differenceInTime = today.getTime() - createdAt.getTime();
  const differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));

  const getReturnPeriod = (membership) => {
    if (membership === "Platinum") {
      return 14;
    }
    if (membership === "Gold") {
      return 10;
    }
    return 7;
  };

  const returnPeriod = userdata?.membership
    ? getReturnPeriod(userdata.membership)
    : 7;

  const handleDownload = async (invoice) => {
    try {
      // const response = await getData(`/order/invoice-download/${id}`);

      const filePath = invoice;

      if (!filePath) {
        console.error("File path is undefined or null");
        return;
      }

      const url = `${IMG_URL}/${filePath}`;

      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.click();
    } catch (error) {
      console.error("Error opening file:", error);
    }
  };

  return (
    <>
      <div className="Successfull_Modal_sec">
        <Modal
          className="Successfull_Modal Purchased_Items_Modal my-account"
          {...props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <div className="product-section-div">
              <div className="d-flex justify-content-between"></div>
              <div>
                <h5 className="order-summary-title">Order Summary</h5>
                <p className="date">
                  Ordered Date: {formatDate(props.data?.createdAt)}
                </p>
                <p className="date">
                  Invoice No: {props.data?.orders_details?.[0]?.invoice_no}
                </p>
                <p className="date">Payment Type: {props.data?.payment_mode}</p>
                <p className="date">
                  Payment Status:{" "}
                  {props.data?.payment_status?.status === 1 ? "Paid" : "UnPaid"}
                </p>
              </div>

              {/* Loop through order details to display each entry separately */}
              {props.data?.orders_details?.map((detail, index) => {
                // Resolve product name

                const productVarientName =
                  detail?.product_multiple_variant?.varient_sub_name ||
                  detail?.product_variant?.v_name;

                const productName = detail?.product?.name;

                // Resolve product image
                const productImage =
                  detail?.product_multiple_variant
                    ?.product_multi_varient_images?.[0]?.image ||
                  detail?.product_variant?.product_images?.[0]?.image;

                // Calculate order status percentage
                const orderStatusPercentMap = {
                  1: 0,
                  2: 34,
                  3: 68,
                  4: 100,
                };
                const orderStatusPercent =
                  orderStatusPercentMap[detail?.order_status_id] || 0;

                // Determine if order is eligible for return
                const isReturnEligible =
                  differenceInDays <= returnPeriod &&
                  detail?.order_status_id === 4;

                return (
                  <>
                    <div key={index} className="order-detail-section">
                      <h4 className="product-title">
                        Item {index + 1}: {productName}({productVarientName})
                      </h4>

                      <div className="download_btn_holder">
                        <button
                          onClick={() => handleDownload(detail?.invoice)}
                          className="btn btn-warning"
                        >
                          Download Invoice
                        </button>
                      </div>

                      <div className="row align-items-center mb-4">
                        <div className="col-xxl-3 col-lg-4 col-md-5 col-sm-6">
                          {productImage ? (
                            <img
                              className="product-image"
                              src={`${IMG_URL}${productImage}`}
                              alt={`Product ${index + 1}`}
                            />
                          ) : (
                            <p className="no-image-text">No Image Available</p>
                          )}
                        </div>

                        <div className="col-xxl-9 col-lg-8 col-md-7 col-sm-6">
                          <h6 className="product-price">
                            Price: ₹
                            {(
                              Number(detail?.price) * Number(detail?.quantity) -
                              (Number(detail?.discount) ?? 0) -
                              (Number(detail?.membershipDiscount) || 0) +
                              Number(detail?.quick_delivery_charges)
                            ).toFixed(2)}
                          </h6>

                          <h6 className="product-price">
                            Shipping Charges: ₹
                            {(Number(detail?.delivery_charges) || 0).toFixed(2)}
                          </h6>

                          <h6 className="product-status">
                            Status: {detail?.order_status?.order_status}
                          </h6>
                        </div>
                      </div>

                      {detail?.order_status_id === 4 ||
                      detail?.order_status_id === 5 ||
                      detail?.order_status_id === 6 ? (
                        <div className="stepper-div">
                          <h5
                            className={`mt-4 status_text ${
                              detail?.order_status_id === 4
                                ? "text_success " // Delivered
                                : detail?.order_status_id === 5
                                ? "text_danger" // Cancelled
                                : "text_warning" // Returned
                            }`}
                          >
                            {detail?.order_status_id === 4
                              ? "Order Has Been Delivered"
                              : detail?.order_status_id === 5
                              ? "Order Has Been Cancelled"
                              : "Order Has Been Returned"}
                          </h5>
                          {isReturnEligible && (
                            <div className="return-button delivered-return-btn">
                              <Common_Button
                                className="return-btn"
                                text="Return"
                                onClick={() =>
                                  navigate(`/order-return/${detail?.id}`)
                                }
                              />
                            </div>
                          )}
                        </div>
                      ) : (
                        <>
                          <h6 className="order">Order Status</h6>
                          <div className="stepper-div">
                            <ProgressBar percent={orderStatusPercent}>
                              {[
                                "Order Placed",
                                "Processing",
                                "Out For Delivery",
                                "Delivered",
                              ].map((step, idx) => (
                                <Step key={idx}>
                                  {({ accomplished }) => (
                                    <div
                                      className={`indexedStep ${
                                        accomplished ? "accomplished" : ""
                                      }`}
                                    >
                                      <div className="range-text-div">
                                        <h6 className="placed">{step}</h6>
                                      </div>
                                    </div>
                                  )}
                                </Step>
                              ))}
                            </ProgressBar>
                          </div>
                        </>
                      )}
                    </div>
                    <div className="divider">
                      <hr />
                    </div>
                  </>
                );
              })}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Purchased_Items_Modal;
